export default __webpack_public_path__ + "static/media/hotel_3.1c2bb079.png";